let clinicalSkill = {
    name: '',
    expiry: 1,
    roles: []
};

export default clinicalSkill;